import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';


@Injectable({
  providedIn: 'root'
})

export class DataMiningService {

    baseUrl: string;
    constructor(private http: HttpClient) {
    }

    public GetData(input: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("DataMining/GetData?input=" + input);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetData', [])));
    }

    public GetTransactionById(id: any): Observable<any> {

        this.baseUrl = environment.apiBase.concat("DataMining/GetTransactionById?Id=" + id);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetTransactionById', [])));
    }
}
